import { array, func, object } from 'prop-types'
import { kuiperClassNames } from '../../utils'
import HeaderCell from '../HeaderCell'
import './styles.scss'

const getStyle = (columnWidths, index) =>
  columnWidths && columnWidths[index] ? { width: columnWidths[index] } : null

const ColumnHeaders = ({
  columns,
  columnWidths,
  customHeaders,
  onChangeWidths,
  onSortClick,
  sortParams,
}) => (
  <tr className={kuiperClassNames('header')}>
    {columns.map((column, index) => (
      <HeaderCell
        /* columns intended to take UI space but have unshown data
        sometimes come through as boolean, `false`,
        instead of as objects with `{visible: false}`
        this addresses that irregularity */
        column={column || { visible: false }}
        customHeader={customHeaders && customHeaders[index]}
        index={index}
        key={index}
        onChangeWidths={onChangeWidths}
        onSortClick={onSortClick}
        sortParams={sortParams}
        style={getStyle(columnWidths, index)}
      />
    ))}
  </tr>
)

ColumnHeaders.propTypes = {
  columns: array.isRequired,
  columnWidths: array,
  customHeaders: array,
  onChangeWidths: func,
  onSortClick: func,
  sortParams: object,
}

export default ColumnHeaders
